import { createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';
import { BookNow, JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';
import { jobSelectors } from 'Douleutaras/redux/data/jobs/jobsSlice';
import { jobBidsSelectors } from 'Douleutaras/redux/data/jobBids/jobBidsSlice';

const jobBidsBookNowAdapter = createEntityAdapter<JSONApiDataObject<BookNow>>({
  selectId: item => item.id
});

export const JOB_BIDS_BOOK_NOW_MODEL_NAME = 'jobBidsBookNow';

export const jobBidsBookNowSlice = createSlice({
  name: JOB_BIDS_BOOK_NOW_MODEL_NAME,
  initialState: jobBidsBookNowAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<BookNow>>),
  reducers: {
    jobBidsBookNowAdded: (state, action) => {
      jobBidsBookNowAdapter.setMany(state, action.payload);
    }
  }
});

export const jobBidsBookNowSelectors = jobBidsBookNowAdapter.getSelectors((state: RootState) => state.jobBidsBookNow);

export const selectBookNowByBidId = createSelector(
  [
    (state, { bidId }: { bidId: string }) => ({ state, bidId })
  ],
  ({ state, bidId }) => {
    let bid;
    let job;
    let bookNowEntry;

    if (bidId) {
      bid = jobBidsSelectors.selectById(state, bidId);
    }
    if (bid && bid.relationships.bookNowEntry) {
      bookNowEntry = jobBidsBookNowSelectors.selectById(state, bid.relationships.bookNowEntry.data.id);
    }

    if (bid && bid.relationships.job) {
      job = jobSelectors.selectById(state, bid.relationships.job.data.id);
    }

    if (!bookNowEntry || !job || !bid) {
      return;
    }

    return {
      bookNowEntry,
      job,
      bid
    };
  }
);
